import { Chip, ChipProps, Theme, withStyles } from '@material-ui/core';
import { red } from '@material-ui/core/colors';

export const ChipIconButton = withStyles({
  root: (props: Record<string, any>) => ({
    boxShadow:
      !props.noShadow &&
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
  }),
  label: {
    paddingLeft: 0,
  },
})(Chip) as typeof Chip;

export const ChipIconButtonRed = withStyles((theme: Theme) => ({
  label: {
    paddingLeft: 0,
  },
  icon: {
    color: theme.palette.getContrastText(red[700]),
  },
  root: (props: Record<string, any>) => ({
    backgroundColor: red[700],
    boxShadow:
      !props.noShadow &&
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    '&:hover': {
      backgroundColor: red[400],
    },
  }),
}))(Chip) as typeof Chip;
